<template>
	<svg width="45" height="45" viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.66667 2.66667C4.90524 2.66667 2.66667 4.90524 2.66667 7.66667C2.66667 10.4281 4.90524 12.6667 7.66667 12.6667H19.3333V15.3333H7.66667C3.43248 15.3333 0 11.9008 0 7.66667C0 3.43248 3.43248 0 7.66667 0C11.9009 0 15.3333 3.43248 15.3333 7.66667H12.6667C12.6667 4.90524 10.4281 2.66667 7.66667 2.66667Z"
		/>
		<path
			d="M20.7198 12.993C21.0678 13.3747 21.0678 13.9586 20.7198 14.3403L18.073 17.2438C17.4577 17.9188 16.334 17.4835 16.334 16.5701L16.334 10.7631C16.334 9.84979 17.4577 9.41447 18.073 10.0895L20.7198 12.993Z"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-sprint-status',
	components: {},
	computed: {},
	props: {}
};
</script>

<style scoped lang="scss">
path.a {
	fill: none;
}
</style>

<docs>
	IconSprintStatus

	```js
	<b-icon-sprint-status />
	```
</docs>
